
export enum PriceMarker {
	i = 'i',
	t = 't',
	d = 'd',
	vp = 'vp'
}